export default {
	palette: {
		primary: {
			light: "#FCEA51",
			main: "#FCEA51",
			dark: "#FCEA51",
			contrastText: "#252525",
		},
		secondary: {
			light: "#e1d9cd",
			main: "#4b5258",
			dark: "#32373a",
			contrastText: "#e1d9cd",
		},
	},
	status: {
		danger: "orange",
	},
	typography: {
		button: {
			fontWeight: 400,
			textAlign: "capitalize",
		},
	},
};
